import DraftIcon from '@/assets/icons/draft-icon';
import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { Can } from '@/features/acl/can';
import { DialogStateManager } from '@/features/dialog/dialog-provider';
import { useLocale } from '@/lib/hooks/use-locale';
import { useNavigate } from 'react-router-dom';
import { DraftOrderCreateDialog } from './draft-order-create-dialog';

export const DropdownMenuItemCreateDraft = () => {
    const { t } = useLocale();
    const navigate = useNavigate();

    const handleTaskCreationClick = () => {
        DialogStateManager.show(DraftOrderCreateDialog, {
            onSuccess: (data) => {
                navigate(`/drafts/${data.draft_order.draft_order_id}/line-items`);
            },
        });
    };

    return (
        <Can I="create" a="SalesDraft">
            <DropdownMenuItem onSelect={handleTaskCreationClick}>
                <DraftIcon className="h-4 w-4" />
                <span>{t('top_navbar__new_draft')}</span>
            </DropdownMenuItem>
        </Can>
    );
};
